/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Divider } from '@material-ui/core';
import ReactPlayer from 'react-player';
import CASE_STUDY, { CaseStudyFormat } from '../../../constants/caseStudy.constants';
import { BASE_URL } from '../../../constants/paths.constants';
import { darkGrey, dividerGrey, footnoteGrey, universalStyles } from '../../../app/theme';
// Note: These commented out lines can be uncommented if we ever need to bring the DICOM viewer back
// import DicomViewerPanel from '../DicomViewerPanel/DicomViewerPanel';
import LocalSpinner from '../LocalSpinner/LocalSpinner';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: darkGrey,
  },
  divider: {
    marginTop: 10,
    marginBottom: 24,
    width: '100%',
    background: dividerGrey,
  },
  paragraphStyles: {
    paddingBottom: 23,
  },
  paragraph: {
    fontStyle: 'italic',
  },
  warning: {
    fontWeight: 600,
  },
  footnote: {
    paddingTop: 8,
    paddingBottom: 0,
    fontSize: 14,
    color: footnoteGrey,
  },
  video: {
    width: '100%',
    aspectRatio: '16/9',
  },
  image: {
    width: '100%',
  },
}));

type ImagingTabTabProps = {
  module: string;
  page: number;
  index?: number;
};

const ImagingTab = ({ module, page, index }: ImagingTabTabProps): JSX.Element => {
  const classes = useStyles();
  const caseStudyData =
    index !== undefined
      ? (CASE_STUDY[module][page.toString()] as CaseStudyFormat[])[index] || {}
      : (CASE_STUDY[module][page.toString()] as CaseStudyFormat) || {};
  const { imaging } = caseStudyData;
  const { heading, paragraph, warning, videoPath, footnote, childNode, imagePath } = imaging;
  const DynamicComponent = childNode;

  return (
    <>
      <Typography className={classes.heading}>{heading}</Typography>
      <Divider className={classes.divider} />
      <div className={classes.paragraphStyles}>
        <Typography display="inline" className={classes.paragraph}>
          {paragraph}
        </Typography>
        <Typography display="inline" className={classes.warning}>
          {warning}
        </Typography>
      </div>
      <div>
        <LocalSpinner />
        {videoPath && (
          <div className={classes.video}>
            <ReactPlayer className={classes.responsiveVideo} url={videoPath} controls />
          </div>
        )}
        {footnote && <Typography className={classes.footnote}>{footnote}</Typography>}
        {DynamicComponent && <DynamicComponent />}
        {/* {dicomIndex && dicomIndex >= 0 && <DicomViewerPanel index={dicomIndex} />} */}
        {imagePath && <img className={classes.image} src={`${BASE_URL}${imagePath.path}`} alt={imagePath.alt} />}
      </div>
    </>
  );
};

export default ImagingTab;
